package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

object ResultPageState {
    var submissionTrial by mutableStateOf(0)
    var hasSubmitted by mutableStateOf(false)
    var hasFailed by mutableStateOf(false)

    fun reset() {
        submissionTrial = 0
        hasSubmitted = false
        hasFailed = false
    }
}